import { RefreshCw } from "@/shared/foundation/icons";
import { Tooltip } from "@/shared/foundation/primitives";

import styles from "./InvocationActivity.module.css";

export const AUTO_REFRESH_INTERVAL_MS = 30_000;

/** Turns the panel's polling on and off. The tooltip is the only place the interval is stated. */
export function AutoRefreshButton({
  on,
  onChange,
}: {
  on: boolean;
  onChange: (on: boolean) => void;
}) {
  return (
    <Tooltip>
      <Tooltip.Trigger
        delay={250}
        render={
          <button
            type="button"
            className={styles.refreshButton}
            aria-label="Auto-refresh"
            aria-pressed={on}
            onClick={() => onChange(!on)}
          />
        }
      >
        <RefreshCw size={16} aria-hidden="true" />
      </Tooltip.Trigger>
      <Tooltip.Content>
        {on
          ? `Auto-refresh is on: every ${AUTO_REFRESH_INTERVAL_MS / 1_000} seconds`
          : "Auto-refresh"}
      </Tooltip.Content>
    </Tooltip>
  );
}
